



export class ZmienHasloMailModel {
    email: string;
}